namespace Matrix.Rebalancer {
    export class InstructionTaskMapColumns {
        static columnsKey = 'Rebalancer.InstructionTaskMap';
    }
}
